import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import settingsService from '../services/settings.service';
import { getLabel, getOverrides, setOverrides, subscribeToLabels } from '../utils/labelStore';

export const LabelsContext = createContext({
	t: getLabel,
	overrides: {},
	refresh: () => {},
});

export function LabelsProvider(props) {
	const [version, setVersion] = useState(0);

	useEffect(() => subscribeToLabels(() => setVersion((v) => v + 1)), []);

	const refresh = useCallback(async () => {
		try {
			const { data } = await settingsService.getTerminology();
			setOverrides((data && data.overrides) || {});
		} catch (ex) {
			// Offline or backend down: keep the localStorage-seeded overrides.
			console.error('Error loading terminology overrides', ex);
		}
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const value = useMemo(
		() => ({ t: getLabel, overrides: getOverrides(), refresh }),
		[version, refresh]
	);

	return <LabelsContext.Provider value={value}>{props.children}</LabelsContext.Provider>;
}
